import api from './index'

const cartService = {
    getCart: () => {
        try {
            // const res = await api.get(`/api/v1/user/carts`)
            const res = {
                data: {
                    success: true,
                    message: 'success',
                    data: {
                        id: 1,
                        total_price: 90.0,
                        status: 'wait_payment',
                        created_at: '2024-07-10T12:11:49.998Z',
                        updated_at: '2024-07-10T12:21:39.562Z',
                        order_items: [
                            {
                                id: 1,
                                created_at: '2024-07-10T12:11:50.004Z',
                                updated_at: '2024-07-10T12:17:14.173Z',
                                item: {
                                    id: 1,
                                    name: '★ Sport Gloves | Slingshot (Battle-Scarred)',
                                    description:
                                        'Exterior: Battle-Scarred   Synthetic fabrics make these athletic gloves durable and eye-catching.   ',
                                    price: 20.0,
                                    float_num: 0.0,
                                    locked_date: null,
                                    is_popular: false,
                                    is_available: true,
                                    exterior: 'Battle-Scarred',
                                    phase: null,
                                    item_type: 'Gloves',
                                    created_at: '2024-06-29T15:20:55.533Z',
                                    updated_at: '2024-07-10T12:11:01.536Z',
                                    images: [
                                        {
                                            url: 'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DAQ1JmMR1osbaqPQJz7ODYfi9W9eOlmImFkOT8PK_unm5Q_tw_2bmZoY703VflqRVlY2jxINeSdwM9MF3VqFe9x-zo1pXv752cyyc36T5iuyibvaYirg',
                                        },
                                    ],
                                },
                            },
                            {
                                id: 1,
                                created_at: '2024-07-10T12:11:50.004Z',
                                updated_at: '2024-07-10T12:17:14.173Z',
                                item: {
                                    id: 1,
                                    name: '★ Sport Gloves | Slingshot (Battle-Scarred)',
                                    description:
                                        'Exterior: Battle-Scarred   Synthetic fabrics make these athletic gloves durable and eye-catching.   ',
                                    price: 20.0,
                                    float_num: 0.0,
                                    locked_date: null,
                                    is_popular: false,
                                    is_available: true,
                                    exterior: 'Battle-Scarred',
                                    phase: null,
                                    item_type: 'Gloves',
                                    created_at: '2024-06-29T15:20:55.533Z',
                                    updated_at: '2024-07-10T12:11:01.536Z',
                                    images: [
                                        {
                                            url: 'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DAQ1JmMR1osbaqPQJz7ODYfi9W9eOlmImFkOT8PK_unm5Q_tw_2bmZoY703VflqRVlY2jxINeSdwM9MF3VqFe9x-zo1pXv752cyyc36T5iuyibvaYirg',
                                        },
                                    ],
                                },
                            },
                            {
                                id: 1,
                                created_at: '2024-07-10T12:11:50.004Z',
                                updated_at: '2024-07-10T12:17:14.173Z',
                                item: {
                                    id: 1,
                                    name: '★ Sport Gloves | Slingshot (Battle-Scarred)',
                                    description:
                                        'Exterior: Battle-Scarred   Synthetic fabrics make these athletic gloves durable and eye-catching.   ',
                                    price: 20.0,
                                    float_num: 0.0,
                                    locked_date: null,
                                    is_popular: false,
                                    is_available: true,
                                    exterior: 'Battle-Scarred',
                                    phase: null,
                                    item_type: 'Gloves',
                                    created_at: '2024-06-29T15:20:55.533Z',
                                    updated_at: '2024-07-10T12:11:01.536Z',
                                    images: [
                                        {
                                            url: 'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DAQ1JmMR1osbaqPQJz7ODYfi9W9eOlmImFkOT8PK_unm5Q_tw_2bmZoY703VflqRVlY2jxINeSdwM9MF3VqFe9x-zo1pXv752cyyc36T5iuyibvaYirg',
                                        },
                                    ],
                                },
                            },
                            {
                                id: 1,
                                created_at: '2024-07-10T12:11:50.004Z',
                                updated_at: '2024-07-10T12:17:14.173Z',
                                item: {
                                    id: 1,
                                    name: '★ Sport Gloves | Slingshot (Battle-Scarred)',
                                    description:
                                        'Exterior: Battle-Scarred   Synthetic fabrics make these athletic gloves durable and eye-catching.   ',
                                    price: 20.0,
                                    float_num: 0.0,
                                    locked_date: null,
                                    is_popular: false,
                                    is_available: true,
                                    exterior: 'Battle-Scarred',
                                    phase: null,
                                    item_type: 'Gloves',
                                    created_at: '2024-06-29T15:20:55.533Z',
                                    updated_at: '2024-07-10T12:11:01.536Z',
                                    images: [
                                        {
                                            url: 'https://community.akamai.steamstatic.com/economy/image/-9a81dlWLwJ2UUGcVs_nsVtzdOEdtWwKGZZLQHTxDZ7I56KU0Zwwo4NUX4oFJZEHLbXH5ApeO4YmlhxYQknCRvCo04DAQ1JmMR1osbaqPQJz7ODYfi9W9eOlmImFkOT8PK_unm5Q_tw_2bmZoY703VflqRVlY2jxINeSdwM9MF3VqFe9x-zo1pXv752cyyc36T5iuyibvaYirg',
                                        },
                                    ],
                                },
                            },
                        ],
                    },
                },
            }

            return { success: true, data: res.data.data }
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Failed to fetch order'
            console.error('API call failed:', error)
            return { success: false, message: errorMessage, error }
        }
    },

    createCart: async (orderData) => {
        try {
            const res = await api.post('/api/v1/user/carts', orderData)
            return { success: true, data: res.data.data }
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Failed to create order'
            console.error('API call failed:', error)
            return { success: false, message: errorMessage, error }
        }
    },

    updateCart: async (orderId, orderData) => {
        try {
            const res = await api.put(`/api/v1/user/carts/${orderId}`, orderData)
            return { success: true, data: res.data.data }
        } catch (error) {
            const errorMessage = error.response?.data?.message || `Failed to update order with ID ${orderId}:`
            console.error('API call failed:', error)
            return { success: false, message: errorMessage, error }
        }
    },

    deleteCart: async (orderId) => {
        try {
            const res = await api.delete(`/api/v1/user/carts/${orderId}`)
            return { success: true, data: res.data }
        } catch (error) {
            console.error(`Failed to delete order with ID ${orderId}:`, error)
            return { success: false, message: `Failed to delete order with ID ${orderId}` }
        }
    },
}

export default cartService
